import { useEffect, useState } from "react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      width: "100%",
      background: "#111",
      color: "#fff",
      padding: "16px",
      textAlign: "center",
      zIndex: 9999
    }}>
      Tento web používá cookies pro správné fungování a budoucí analýzu návštěvnosti.
      <button
        onClick={accept}
        style={{
          marginLeft: "12px",
          padding: "8px 16px",
          background: "#fff",
          color: "#000",
          border: "none",
          cursor: "pointer"
        }}
      >
        Souhlasím
      </button>
    </div>
  );
}